export default {
  unavailable: {
    title: 'Acest serviciu este operat de Foodamigos',
    description:
      'Tipărirea flyerelor și autocolantelor este un serviciu operat de echipa Foodamigos și nu este disponibil pentru conturile partenere.',
  },
};
